import config from "./config";
var axios = config();

export default {
  // get
  getIncidentById(id) {
    return axios.get("/api/Incidents/GetIncidentById/" + id);
  },

  getIncidents() {
    return axios.get("/api/Incidents/GetIncidents");
  },

  getIncidentsBySubmitter(submitterId) {
    return axios.get("/api/Incidents/GetIncidentsBySubmitter/" + submitterId);
  },

  getStatusDefinitions() {
    return axios.get("/api/Incidents/GetStatusDefinitions");
  },

  getRecommendations() {
    return axios.get("/api/Incidents/GetRecommendations");
  },

  // post
  createIncident(incident) {
    return axios.post("/api/Incidents/CreateIncident", incident);
  },

  createIncidentEmail(incidentId, subject) {
    return axios.post(
      "/api/Incidents/CreateIncidentEmail/" + incidentId + "/" + subject
    );
  },

  // put
  submitFollowUp(incident) {
    return axios.put("/api/Incidents/EditFollowUp", incident);
  },

  editIncident(incident) {
    return axios.put("/api/Incidents/EditIncident", incident);
  }
};
